var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebcamWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5946 20.6757C19.2965 20.6757 23.1081 16.8641 23.1081 12.1622C23.1081 7.46031 19.2965 3.64868 14.5946 3.64868C9.89268 3.64868 6.08105 7.46031 6.08105 12.1622C6.08105 16.8641 9.89268 20.6757 14.5946 20.6757ZM14.5946 20.6757V25.5406M8.51349 25.5406H14.5946M14.5946 25.5406H20.6756M18.2432 12.1622C18.2432 14.1773 16.6097 15.8108 14.5946 15.8108C12.5795 15.8108 10.9459 14.1773 10.9459 12.1622C10.9459 10.1471 12.5795 8.51355 14.5946 8.51355C16.6097 8.51355 18.2432 10.1471 18.2432 12.1622Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcamWhite);
export default __webpack_public_path__ + "static/media/webcamWhite.c9d99fe34b7c15f1bed011f98158bb98.svg";
export { ForwardRef as ReactComponent };